module.exports = __webpack_public_path__ + "media/img/frontend_application/christmas/partner-three-8f64b28e7a9574e800c66a8831b5ec5b.png";